import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { DocumentRevisionLinkService } from 'src/app/Service/document-revision-link/document-revision-link.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { Module } from 'src/app/Service/element-details.data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-document-revision-link',
  templateUrl: './document-revision-link.component.html',
  styleUrls: ['./document-revision-link.component.css']
})
export class DocumentRevisionLinkComponent implements OnInit {

  public editService: any;
  public editedRowIndex: any;
  public editedProduct: any;
  public groupDropdown: any[] = [];
  public stageDropdown!: any[];
  public docRevisionList: any[] = [];
  public groupId!: number | null;
  public statusDisable: boolean = true;
  public setDisable: boolean = false;
  public formGroup!: FormGroup;

  @ViewChild(GridComponent)
  private grid!: GridComponent;

  constructor(private documentRevisionLinkService: DocumentRevisionLinkService, public notificationService: NotificationService,
    private mapRoleFeatureService: MapRoleFeatureService, private commonService: CommonService) { }


  ngOnInit() {
    this.getBusinessGroupList();
    this.getgroupValue();
  }

  getBusinessGroupList() {
    this.mapRoleFeatureService.getBusinessGroups(this.commonService.getProjectId()).subscribe((data: BusinessGroupModel[]) => {
      this.groupDropdown = data;
    });
  }

  getDocumentRevision() {
    let obj = {
      "projectId": this.commonService.getProjectId(),
      "groupId": this.groupId,
    }
    this.documentRevisionLinkService.getDocumentRevision(obj).subscribe(data => {
      this.docRevisionList = data;
    })
  }

  getgroupValue() {
    this.mapRoleFeatureService.getDedAgainstDe("Workflow Status", this.groupId, Module.Workflow, null, null, this.commonService.getProjectId()).subscribe(data => {
      this.stageDropdown = data;
    });
    // this.documentRevisionLinkService.getGroupData().subscribe(data => {
    //   this.stageDropdown = data;
    // });
  }
  groupValueChange(val: any) {
    if (val.value != '-2') {
      this.groupId = val.additionalValues.additionalValues.group_Id;
      this.getDocumentRevision();
      this.getgroupValue();
    } else {
      this.groupId = null;
      this.docRevisionList = [];
    }
  }

  public addHandler(data: any) {
    this.closeEditor(data.sender, this.editRowIndex);
    if (!this.groupId) {
      this.notificationService.showToast("Please Select any one in Group", "Warning");
      return;
    }
    this.statusDisable = true;
    this.setDisable = false;
    this.formGroup = new FormGroup({
      'stage': new FormControl('', Validators.required),
      'revision': new FormControl('', Validators.required),
      'active_status': new FormControl(true)
    });
    this.grid.addRow(this.formGroup);

  }
  public editRowIndex: number | undefined;
  public editHandler(data: any) {
    this.editRowIndex = data.rowIndex;
    this.statusDisable = false;
    this.setDisable = true;
    this.formGroup = new FormGroup({
      'stage': new FormControl(data.dataItem.stageId),
      'revision': new FormControl(data.dataItem.revisionNo),
      'active_status': new FormControl(data.dataItem.isActive),
    });
    this.closeEditor(data.sender);
    this.editedRowIndex = data.rowIndex;
    this.editedProduct = Object.assign({}, data.dataItem);
    data.sender.editRow(data.rowIndex);
  }

  public cancelHandler(data: any) {
    this.closeEditor(data.sender, data.rowIndex);
  }

  // stageValueChange(val: any) {   
  //  if (val.value != '-2'){    
  //     this.formGroup.get('stage').setValue(val.desc);
  //  }else {
  //   this.formGroup.get('stage').setValue(null);
  //  }
  // }

  public saveHandler(data: any) {
    data.dataItem = this.formGroup.value;
    let obj = {};
    if (!this.groupId) {
      this.notificationService.showToast("Please Select any one in Group", "Warning");
      return;
    }
    if (!data.dataItem.stage) {
      this.notificationService.showToast("Please Select any one in Stage", "Warning");
      return;
    }
    if (!data.dataItem.revision) {
      this.notificationService.showToast("Please Enter Revision", "Warning");
      return;
    }
    let findDuplicate;
    if (data.isNew) {
      let checkExist = this.stageDropdown.filter(x => x.dedId == data.dataItem.stage)[0];
      findDuplicate = this.docRevisionList.filter(x => x.stageDescription == checkExist.dedDescription)[0];
    } else {
      let checkExist = this.stageDropdown.filter(x => x.dedId == data.dataItem.stage)[0];
      findDuplicate = this.docRevisionList.filter(x => x.stageDescription == checkExist.dedDescription && x.isActive == data.dataItem.active_status && x.revisionNo == data.dataItem.revision.trimStart().trimEnd())[0];
    }
    if (!!findDuplicate) {
      this.notificationService.showToast("Duplicate Stage/No data changed", "Warning");
      return;
    }
    if (!!data.dataItem) {
      if (data.isNew) {
        let selectedStage = this.stageDropdown.filter(x => x.dedId == data.dataItem.stage)[0];
        obj = {
          "projectId": this.commonService.getProjectId(),
          "groupId": this.groupId,
          "stageId": data.dataItem.stage,
          "stageDescription": selectedStage.dedDescription,
          "created_By": this.commonService.getLoggedInUserId(),
          "created_On": new Date(),
          "revisionNo": data.dataItem.revision.trimStart().trimEnd(),
          "isActive": data.dataItem.active_status,
          "isDelete": false,
        }
        this.documentRevisionLinkService.insertDocumentRevision(obj).subscribe(data => {
          if (data.successCode == 200) {
            this.notificationService.showToast(data.successMessage, "Success");
            this.getDocumentRevision();
          }
        });
      }
      else {
        let selectedStage = this.stageDropdown.filter(x => x.dedId == data.dataItem.stage)[0];
        obj = {
          "projectId": this.commonService.getProjectId(),
          "groupId": this.groupId,
          "stageId": data.dataItem.stage,
          "stageDescription": selectedStage.dedDescription,
          "modified_By": this.commonService.getLoggedInUserId(),
          "modified_On": new Date(),
          "revisionNo": data.dataItem.revision.trimStart().trimEnd(),
          "isActive": data.dataItem.active_status,
          "isDelete": false,
        }
        this.documentRevisionLinkService.insertDocumentRevision(obj).subscribe(data => {
          if (data.successCode == 200) {
            this.notificationService.showToast(data.successMessage, "Success");
            this.getDocumentRevision();
          }
        });
      }
    }
    data.sender.closeRow(data.rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
  }

  public removeHandler(data: any) {
    let obj = {};
    if (!!data.dataItem) {
      data.dataItem.isDelete = true;
      obj = {
        "projectId": this.commonService.getProjectId(),
        "groupId": data.dataItem.groupId,
        "stageId": data.dataItem.stageId,
        "stageDescription": null,
        "modified_By": this.commonService.getLoggedInUserId(),
        "modified_On": new Date(),
        "revisionNo": data.dataItem.revisionNo.trimStart().trimEnd(),
        "isActive": data.dataItem.isActive,
        "isDelete": true,
      }
      this.documentRevisionLinkService.insertDocumentRevision(obj).subscribe(data => {
        if (data.successCode == 200) {
          this.notificationService.showToast(data.successMessage, "Success");
          this.getDocumentRevision();
        }
      });
    }
  }

  private closeEditor(grid: { closeRow: (arg0: any) => void; }, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
  }


}
